<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create User</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Modify User</md-dialog-title>
      <md-dialog-title v-if="mode==='reset'">Reset Password</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSaveUser">
          <md-field :class="getValidationClass('dataForm.username')">
            <label for="username">Username</label>
            <md-input name="username"
                      id="username"
                      autocomplete="new-password"
                      v-model="dataForm.username"
                      :disabled="mode!=='create'"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.username.required">Username is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.username.minLength">Invalid username<br/></div>
            </div>
          </md-field>

          <md-field :class="getValidationClass('dataForm.name')" v-if="mode !=='reset'">
            <label for="username">Name</label>
            <md-input name="name" id="name" autocomplete="new-password" v-model="dataForm.name"/>
            <span class="md-error" v-if="!$v.dataForm.name.required">Name is required</span>
            <span class="md-error" v-else-if="!$v.dataForm.name.minLength">Invalid name</span>
          </md-field>

          <md-field v-if="mode==='create' || mode==='reset'" :class="getValidationClass('dataForm.password')">
            <label for="password">Password</label>
            <md-input name="password" id="password" autocomplete="new-password" type="password"
                      v-model="dataForm.password"/>
            <span class="md-error" v-if="!$v.dataForm.password.required">Password is required<br/></span>
            <span class="md-error" v-else-if="!$v.dataForm.password.minLength">Invalid password<br/></span>
          </md-field>

          <template v-if="mode !=='reset'">

            <md-field :class="getValidationClass('dataForm.category')">
              <label>Category</label>
              <md-select v-model="dataForm.category" name="user-pool" id="user-pool">
                <md-option :key="c.tagId" v-for="c in getMasterDataByGroup('UserCategory')" :value="c.tagId">
                  {{c.tagName}}
                </md-option>
              </md-select>
              <div class="md-error" v-if="!$v.dataForm.category.required">Category is required<br/></div>
            </md-field>

            <auto-complete-master-data-select :class="getValidationClass('dataForm.companyId')"
                                              group="Company"
                                              label="Company"
                                              :init-value="dataForm.companyName"
                                              :on-item-changed="handleCompanyChanged">
            </auto-complete-master-data-select>
            <md-field :class="getValidationClass('dataForm.companyId')">
              <label>Company Id</label>
              <md-input disabled v-model="dataForm.companyId"/>
              <span class="md-error" v-if="!$v.dataForm.companyId.required">Company is required</span>
            </md-field>
            <md-field :class="getValidationClass('dataForm.country')">
              <label>Country</label>
              <md-select v-model="dataForm.country" name="country" id="country">
                <md-option :key="c.tagId" v-for="c in getMasterDataByGroup('Country')" :value="c.tagId">
                  {{c.tagId}}({{c.tagName}})
                </md-option>
              </md-select>
              <span class="md-error" v-if="!$v.dataForm.country.required">Country is required</span>
            </md-field>
            <md-field :class="getValidationClass('dataForm.mobileNo')">
              <label for="username">Mobile No</label>
              <md-input name="mobileNo" id="mobileNo" autocomplete="new-password"
                        v-model="dataForm.mobileNo"/>
              <span class="md-error" v-if="!$v.dataForm.mobileNo.required">Mobile No is required</span>
            </md-field>
            <md-field :class="getValidationClass('dataForm.mfaMobileNo')">
              <label for="username">MFA Mobile No</label>
              <md-input name="mobileNo" id="mobileNo" autocomplete="new-password"
                        v-model="dataForm.mfaMobileNo"/>
              <span class="md-error" v-if="!$v.dataForm.mfaMobileNo.required">Mobile No is required</span>
            </md-field>
            <md-field :class="getValidationClass('dataForm.email')">
              <label for="username">Email</label>
              <md-input name="email" id="email" autocomplete="new-password" v-model="dataForm.email"/>
              <span class="md-error" v-if="!$v.dataForm.email.required">Email is required</span>
            </md-field>
            <auto-complete-master-data-select :class="getValidationClass('dataForm.defaultSalesOffice')"
                                              group="GST_SALEOFFICE"
                                              label="Sales Office"
                                              :init-value="dataForm.defaultSalesOffice"
                                              :on-item-changed="handleSalesOfficeChanged">
            </auto-complete-master-data-select>

            <auto-complete-master-data-select :class="getValidationClass('dataForm.recWindow')"
                                              group="USER_REC_WIN"
                                              label="Receive Window"
                                              :init-value="dataForm.recWindow"
                                              :on-item-changed="handleRecWindowChanged">
            </auto-complete-master-data-select>

            <div>
              <md-switch v-model="dataForm.disabled">Disabled</md-switch>
            </div>
            <!--
            <div style="margin-top: -50px; margin-left: 200px; color: red;">
              <md-switch v-model="dataForm.loginWithMFA" @change="onChangeMFA">MFA Login</md-switch>
            </div>
          -->
            <div class="result-included-outter-div">
              <div style="margin-top: 0px; margin-left: 0px; color: red;">
                <md-switch v-model="dataForm.loginWithMFA" @change="onChangeMFA">MFA Login</md-switch>
              </div>
              <div class="result-included-inner-div-radio">
                <span class="result-included-span-radio">
                   MFA Methods:
                </span>
                <md-radio v-model="mfa_method" value="SMS" @change="onSelectMFA" :disabled="!mfa_enabled">SMS</md-radio>
                <md-radio v-model="mfa_method" value="EMAIL" @change="onSelectMFA" :disabled="!mfa_enabled">EMAIL</md-radio>
                <md-radio v-model="mfa_method" value="TOTP" @change="onSelectMFA" :disabled="!mfa_enabled">Authenticator App</md-radio>
                <div class="result-included-checkbox">
                    <md-checkbox v-model="dataForm.firstTimeTOTP" :disabled="!mfa_totp_enabled">first time QR Code</md-checkbox>
                </div>
              </div>
            </div>

            <h4>Walmart Fields</h4>
            <md-field :class="getValidationClass('dataForm.driverGroup')">
              <label>Driver Group</label>
              <md-select v-model="dataForm.driverGroup" name="driverGroup" id="driverGroup">
                <md-option :key="c.tagId" v-for="c in getMasterDataByGroup('DriverGroup')" :value="c.tagId">{{c.tagName}}
                </md-option>
              </md-select>
              <div class="md-error" v-if="!$v.dataForm.driverGroup.requiredIfIsDriver">Driver Region is required</div>
            </md-field>
            <md-field :class="getValidationClass('dataForm.driverRegion')">
              <label>Driver Region</label>
              <md-select v-model="dataForm.driverRegion" name="driverRegion" id="driverRegion">
                <md-option :key="c.tagId" v-for="c in getMasterDataByGroup('DriverRegion')" :value="c.tagId">{{c.tagName}}</md-option>
              </md-select>
            </md-field>
            <auto-complete-master-data-select
                group="RouteID"
                label="Route"
                :init-value="getRouteInitValue"
                :on-item-changed="handleRouteChanged">
            </auto-complete-master-data-select>
            <calling-api type="bar" path="/api/w/users">
              <div :class="getValidationClass('dataForm.dispatcher')">
                <auto-complete-master-data-select
                    v-if="dispatchers.length> 0"
                    :prepared-options="dispatchers"
                    label="Dispatcher"
                    :init-value-id="dataForm.dispatcher"
                    :on-item-changed="handleDispatcherChanged">
                </auto-complete-master-data-select>
                <div class="md-error" v-if="!$v.dataForm.dispatcher.requiredIfIsDriver">Dispatcher is required</div>
              </div>
            </calling-api>
            <div :class="getValidationClass('dataForm.endOutlet')">
              <auto-complete-master-data-select
                  label="End Outlet"
                  group="EndOutlet"
                  :init-value-id="dataForm.endOutlet"
                  :on-item-changed="handleEndOutletChanged">
              </auto-complete-master-data-select>
              <div class="md-error" v-if="!$v.dataForm.endOutlet.requiredIfIsYard">End Outlet is required</div>
            </div>

            <h4>CCIC Fields</h4>

            <master-data-select label="CCIC Supplier Group" group="CCIC_SUPPLIER_GROUPS" v-model="dataForm.ccicSupplierGroup"/>

            <md-field>
              <label for="ccicEmailTo">CCIC Email To (use ";" to separate)</label>
              <md-input name="ccicEmailTo" id="ccicEmailTo" v-model="dataForm.ccicEmailTo"/>
            </md-field>

            <md-field>
              <label for="ccicEmailCc">CCIC Email CC (use ";" to separate)</label>
              <md-input name="ccicEmailCc" id="ccicEmailCc" v-model="dataForm.ccicEmailCc"/>
            </md-field>

            <auto-complete-master-data-multiple-select
                label="CCIC Team"
                v-model="dataForm.ccicTeams"
                group="CCIC_TEAM"
            />

            <master-data-select
                label="CCIC Team Remark"
                group="CCIC_TEAM"
                v-model="dataForm.ccicTeamRemark"
            />

            <master-data-select
                label="CCIC Role"
                v-model="dataForm.ccicRole"
                group="CCIC_ROLE"
            />

            <calling-api type="bar" path="/api/w/users">
              <auto-complete-master-data-select
                  v-if="dispatchers.length> 0"
                  :prepared-options="ccicQcUsers"
                  label="CCIC User Alias"
                  :watch-value-id="dataForm.ccicUserAlias"
                  :init-value-id="dataForm.ccicUserAlias"
                  :on-item-changed="handleCcicUserAliasChanged">
              </auto-complete-master-data-select>
            </calling-api>

            <div>
              <md-switch v-model="dataForm.ccicReadOnly">CCIC readonly</md-switch>
            </div>

          </template>

          <calling-api v-if="mode==='create'" type="bar" path="/api/w/users/create">
            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>
          </calling-api>

          <calling-api v-if="mode==='update'" type="bar" path="/api/w/users/update">
            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>
          </calling-api>

          <calling-api v-if="mode==='reset'" type="bar" path="/api/w/users/update">
            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" @click="handleResetPasswordClicked" class="md-accent">Reset Password</md-button>
            </md-dialog-actions>
          </calling-api>

        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 25px;
    margin-left: 2px;
}

.result-included-inner-div-radio {
    margin-left: 138px !important;
    margin-top: -51px !important;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}
.result-included-checkbox {
    margin-top: -10px;
    margin-left: 295px;
    margin-bottom: 5px;
}

</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required } from 'vuelidate/lib/validators';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import { updateMFAPreference } from 'aws-amplify/auth';

  const getInitialdataForm = () => ({
    username: null,
    name: null,
    password: null,
    category: null,
    companyId: null,
    companyName: null,
    country: null,
    mobileNo: null,
    mfaMobileNo: null,
    email: null,
    defaultSalesOffice: null,
    recWindow: null,
    driverGroup: null,
    driverRegion: null,
    dispatcher: null,
    endOutlet: null,
    disabled: false,
    loginWithMFA: false,
    mfaMethod: null,
    firstTimeTOTP: false,
    ccicSupplierGroup: null,
    ccicEmailTo: null,
    ccicEmailCc: null,
    ccicTeams: [],
    ccicTeamRemark: null,
    ccicRole: null,
    ccicUserAlias: null,
    ccicReadOnly: false,
  });

  export default {
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      dispatchers: [],
      ccicQcUsers: [],
      mfa_method: null,
      mfa_enabled: null,
      mfa_totp_enabled: null,
      mfa_currentState: null,
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
      ]),
      getRouteInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        if (this.dataForm.routeId && this.dataForm.routeDesc) {
          return `${this.dataForm.routeDesc} (${this.dataForm.routeId})`;
        }
        return null;
      },
    },
    watch: {},
    validations: {
      dataForm: {
        username: {
          required,
          minLength: minLength(3),
        },
        name: {
          required,
        },
        password: {
          required,
          minLength: minLength(8),
        },
        category: {
          required,
        },
        companyId: {
          required,
        },
        country: {
          // required,
        },
        mobileNo: {
          // required,
        },
        mfaMobileNo: {
          // required,
        },
        email: {
          // required,
        },
        dispatcher: {
          requiredIfIsDriver(val) {
            if (this.dataForm.category !== 'A') {
              return true;
            }
            return !!val;
          },
        },
        driverGroup: {
          requiredIfIsDriver(val) {
            if (this.dataForm.category !== 'A') {
              return true;
            }
            return !!val;
          },
        },
        endOutlet: {
          requiredIfIsDriver(val) {
            if (this.dataForm.category !== 'C') {
              return true;
            }
            return !!val;
          },
        },

      },
    },
    methods: {
      openDialog(existingUser) {
        this.$v.dataForm.$reset();
        this.dataForm = getInitialdataForm();
        console.log(`user openDialog`, JSON.stringify(existingUser));
        if (existingUser && this.mode === 'update') {
          this.dataForm.username = existingUser.username;
          this.dataForm.name = existingUser.name;
          this.dataForm.password = 'fake_password';
          this.dataForm.category = existingUser.category;
          this.dataForm.companyId = existingUser.companyId;
          this.dataForm.companyName = existingUser.companyName;
          this.dataForm.country = existingUser.country;
          this.dataForm.mobileNo = existingUser.mobileNo;
          this.dataForm.mfaMobileNo = existingUser.mfaMobileNo;
          this.dataForm.dispatcher = existingUser.dispatcher;
          this.dataForm.email = existingUser.email;
          this.dataForm.defaultSalesOffice = existingUser.defaultSalesOffice;
          this.dataForm.recWindow = existingUser.recWindow;
          this.dataForm.driverGroup = existingUser.driverGroup;
          this.dataForm.driverRegion = existingUser.driverRegion;
          this.dataForm.routeId = existingUser.routeId;
          this.dataForm.routeDesc = existingUser.routeDesc;
          this.dataForm.endOutlet = existingUser.endOutlet;
          this.dataForm.disabled = existingUser.disabled;
          this.dataForm.ccicEmailCc = existingUser.ccicEmailCc;
          this.dataForm.ccicEmailTo = existingUser.ccicEmailTo;
          this.dataForm.ccicSupplierGroup = existingUser.ccicSupplierGroup;
          this.dataForm.ccicTeams = existingUser.ccicTeams;
          this.dataForm.ccicTeamRemark = existingUser.ccicTeamRemark;
          this.dataForm.ccicRole = existingUser.ccicRole;
          this.dataForm.ccicUserAlias = existingUser.ccicUserAlias;
          this.dataForm.ccicReadOnly = existingUser.ccicReadOnly === true;
          this.dataForm.loginWithMFA = existingUser.loginWithMFA;
          this.mfa_method = existingUser.mfaMethod;
          this.dataForm.mfaMethod = existingUser.mfaMethod;
          this.dataForm.firstTimeTOTP = existingUser.firstTimeTOTP;
          if (this.dataForm.loginWithMFA == true)
          {
             this.mfa_enabled = true;
             if (this.mfa_method == 'TOTP')
             {
                this.mfa_totp_enabled = true;
             } else {
                this.mfa_totp_enabled = false;
             }
          } else {
             this.mfa_enabled = false;
          }
        }

        if (existingUser && this.mode === 'reset') {
          this.dataForm.username = existingUser.username;
        }

        this.dispatchers = [];
        //api.post('/api/w/users', { category: 'B' })
        newAPIPost('/api/w/users', { category: 'B' })
          .then((res) => {
            this.dispatchers = _(res)
              .filter(it => it.disabled !== true)
              .map(it => ({
                id: it.username,
                name: it.name,
              }));
          });
        this.ccicQcUsers = [];
        //api.post('/api/w/users', { category: 'G' })
        newAPIPost('/api/w/users', { category: 'G' })
          .then((res) => {
            this.ccicQcUsers = _(res)
              .filter(it => it.disabled !== true)
              .map(it => ({
                id: it.username,
                name: it.name,
              }));
          });

        this.showDialog = true;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      handleCompanyChanged(id, name) {
        console.log(`handleCompanyChanged`, id, name);
        this.dataForm.companyId = id;
        this.dataForm.companyName = name;
      },
      handleRouteChanged(id, name) {
        this.dataForm.routeId = id;
        this.dataForm.routeDesc = name;
      },
      handleDispatcherChanged(id) {
        this.dataForm.dispatcher = id;
      },
      handleSalesOfficeChanged(id) {
        this.dataForm.defaultSalesOffice = id;
      },
      handleRecWindowChanged(id) {
        this.dataForm.recWindow = id;
      },
      handleEndOutletChanged(id) {
        this.dataForm.endOutlet = id;
      },
      handleCcicUserAliasChanged(id) {
        this.dataForm.ccicUserAlias = id;
      },
      handleResetPasswordClicked() {
        const { username, password } = this.dataForm;

        if (!window.confirm(`Reset password for user ${username} ?`)) {
          return;
        }

        this.$store.dispatch(`updateUser`, {
          action: 'RESET_PASSWORD',
          username,
          password,
        })
          .then(() => {
            this.showDialog = false;
          })
          .then(() => {
            this.$store.dispatch('loadUsers');
          });
      },
      onSelectMFA(method)
      {
         console.log(`Selected MFA method: ${this.mfa_method} `);
         this.mfa_totp_enabled = false;
         if (method == 'EMAIL')
         {
            if (this.dataForm.email == null || this.dataForm.email == '')
            {
                alert('User email required for EMAIL MFA!');
                this.mfa_method = "";
            }
            this.dataForm.firstTimeTOTP = false;
         }
         if (method == 'SMS')
         {
            if (this.dataForm.mfaMobileNo == null || this.dataForm.mfaMobileNo == '')
            {
                alert('User MFA Mobile number required for SMS MFA!');
                this.mfa_method = "";
            }
            this.dataForm.firstTimeTOTP = false;
         }
         if (method == 'TOTP')
         {
            this.mfa_totp_enabled = true;
         }
         this.dataForm.mfaMethod = method;
      },
      onChangeMFA() {
         this.mfa_enabled = this.dataForm.loginWithMFA;
         if (this.mfa_enabled != true)
         {
            this.mfa_method = "";
         } 
      },
      async disableMFA(user) {
          try {
            await Auth.setPreferredMFA(user, 'NOMFA');
          } catch (error) {
            console.log(`Error disabling user's MFA: ${JSON.stringify(error)}`);
          }
      },
      async doSaveUser() {
        
        this.$v.dataForm.$touch();

        console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);

        if (this.$v.dataForm.$invalid) {
          return;
        }

        if (this.dataForm.loginWithMFA == true)
        {
            if (this.mfa_method == 'EMAIL') {
               if (this.dataForm.email == null || this.dataForm.email == '')
               {
                  alert('User email required for EMAIL MFA!');
                  return;
               } else {
                  //await updateMFAPreference({ email: 'PREFERRED'});
                  this.dataForm.mfaMethod = 'EMAIL';
               }
            }
            
            if (this.mfa_method == 'SMS') {
               if (this.dataForm.mfaMobileNo == null || this.dataForm.mfaMobileNo == '')
               {
                  alert('User MFA Mobile number required for SMS MFA!');
                  return;
               } else {
                  const checkphonenum = RegExp(/^1[1-9][0-9]{9}$/);
                  //if (!checkphonenum.test(this.dataForm.mobileNo))
                  if (!checkphonenum.test(this.dataForm.mfaMobileNo))
                  {
                    this.$buefy.notification.open({
                         duration: 10000,
                         message: `Input Phone number ${this.dataForm.mfaMobileNo} is not in 1[phone number] format(Only accept US Num)!`,
                         position: 'is-top',
                         type: 'is-danger',
                         hasIcon: true
                    })
                    return;          
                  }
                  this.dataForm.mfaMethod = 'SMS';
               }
            }
        } else {
          this.dataForm.mfaMethod = '';
        }
        // console.log(`save user loginwithmfa: ${this.dataForm.loginWithMFA} and mode: ${this.mode}`);
        // if (this.dataForm.loginWithMFA == false && this.mode == 'update')
        // {
        //     const user = await Auth.currentAuthenticatedUser();
        //     console.log(`save user disablemfa user: ${JSON.stringify(user)}`);
        //     const checkusermfa = await Auth.getPreferredMFA(user);
        //     console.log(`save user disablemfa checkusermfa: ${JSON.stringify(checkusermfa)}`);
        //     if (checkusermfa != null && checkusermfa != 'NOMFA')
        //     {
        //        await this.disableMFA(user);
        //     }
        // }

 
        // //if (this.dataForm.loginWithMFA == true && (this.dataForm.mobileNo == null || this.dataForm.mobileNo == ''))
        // if (this.dataForm.loginWithMFA == true && (this.dataForm.mfaMobileNo == null || this.dataForm.mfaMobileNo == '' || this.dataForm.email == null || this.dataForm.email == ''))
        // {
        //     alert("Setting up Login with MFA would require Mobile No and Email!");
        //     return;            
        // } else {
        //   //if (this.dataForm.mobileNo != null && this.dataForm.mobileNo != '')
        //   if (this.dataForm.mfaMobileNo != null && this.dataForm.mfaMobileNo != '')
        //   {
        //      const checkphonenum = RegExp(/^1[1-9][0-9]{9}$/);
        //      //if (!checkphonenum.test(this.dataForm.mobileNo))
        //      if (!checkphonenum.test(this.dataForm.mfaMobileNo))
        //      {
        //         this.$buefy.notification.open({
        //               duration: 10000,
        //               message: `Input Phone number ${this.dataForm.mfaMobileNo} is not in 1[phone number] format(Only accept US Num)!`,
        //               position: 'is-top',
        //               type: 'is-danger',
        //               hasIcon: true
        //         })
        //         return;          
        //      }
        //    }
        //    //this.dataForm.mobileNo = `+${this.dataForm.mobileNo}`;
        // }
        // console.log(`save user loginwithmfa: ${this.dataForm.loginWithMFA} and mode: ${this.mode}`);
        // if (this.dataForm.loginWithMFA == false && this.mode == 'update')
        // {
        //     const user = await Auth.currentAuthenticatedUser();
        //     console.log(`save user disablemfa user: ${JSON.stringify(user)}`);
        //     const checkusermfa = await Auth.getPreferredMFA(user);
        //     console.log(`save user disablemfa checkusermfa: ${JSON.stringify(checkusermfa)}`);
        //     if (checkusermfa != null && checkusermfa != 'NOMFA')
        //     {
        //        await this.disableMFA(user);
        //     }
        // }

        const promise = this.mode === 'create' ?
          this.$store.dispatch("createUser", this.dataForm)
          :
          this.$store.dispatch("updateUser", this.dataForm);

        promise
          .then(() => {
            this.showDialog = false;
          })
          .then(() => {
            this.$store.dispatch('refreshUserProfile');
            this.$store.dispatch('loadUsers');
          });
      },
    },
  };
</script>
